import React, { ChangeEvent } from 'react'
import DateTimeRangeFilter, {
  DateFilterObject,
} from '../../../../common/filter/DateTimeRangeFilter'
import { IFiltersExternalUserFlagsProps } from './Filters.types'

export const FiltersExternalUserFlags = (props: IFiltersExternalUserFlagsProps) => {
  const { filters, hasExport } = props
  const { onApplyFilters, onFiltersChange, onResetFilter, onExport } = props

  const updateTime = (filterData: DateFilterObject) => {
    onFiltersChange({
      ...filters,
      dateStart: filterData.dateStart,
      dateEnd: filterData.dateEnd,
    })
  }

  const updateUserId = (event: ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({
      ...filters,
      userId: event.target.value,
    })
  }

  return (
    <>
      <div className='d-flex flex-column flex-md-row flex-lg-column flex-xxl-row gap-4 align-items-center'>
        <DateTimeRangeFilter
          filter={filters}
          updateTime={updateTime}
          hideRanges
          className='w-100'
        />
        <div className='d-flex flex-column flex-sm-row flex-md-column flex-lg-row w-100 gap-4 align-items-md-center'>
          <button className='btn btn-primary' onClick={onResetFilter}>
            Сбросить фильтр
          </button>

          {hasExport && (
            <button className='btn btn-success' onClick={() => onExport?.()}>
              Экспортировать
            </button>
          )}
        </div>
      </div>
      <div className='mt-5'>
        <div className='position-relative'>
          <span className='svg-icon svg-icon-3 svg-icon-gray-500 position-absolute pt-4 ms-3'>
            <i className='fa fa-search'></i>
          </span>
          <input
            name='userId'
            placeholder='Поиск по ID клиента'
            type='text'
            value={filters.userId || ''}
            onChange={updateUserId}
            className='form-control form-control-solid ps-10 pt-3 pb-2'
          />
        </div>
      </div>
    </>
  )
}
